//Librerie esterne
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import he from "he";

//Hooks
import useArticoli from '../../hooks/useGetArticoli';

//Configurazioni
import { appConfig } from "../../config/appConfig";

const LastArticles: React.FC = () => {

    const { t } = useTranslation();

    const formatDate = (dateString: string | null, t: (key: string) => string): string => {
        if (!dateString) return t('blog.date.unavailable');
        try {
            const date = new Date(dateString);
            if (isNaN(date.getTime())) {
                return t('blog.date.invalid');
            }
            return date.toLocaleDateString('it-IT', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            });
        } catch (e) {
            console.error("Error formatting date:", dateString, e);
            return t('blog.date.invalid');
        }
    };

    const { articles } = useArticoli({
        agencyId: appConfig.agency.id,
        initialLimit: 3,
    });

    return (
        <section id="last-articles" className="space-ptb">
            <div className="container-fluid">
                <div className="section-title text-center">
                    <h3 className="asH2SubTitle">{t('homePage.lastArticlesSection.title')}</h3>
                </div>
                <div className="row justify-content-center">
                    {articles.map((article, index) => (
                        <div className="col-12 col-md-6 col-lg-4" key={index}>
                            <Link to={`/articolo/${article.id}-${article.seoString}`} className="p-3 mb-3 blog-card">
                                <img
                                    className="img-fluid"
                                    src={article.foto ? `https://www.casagest24.it/${article.foto}` : '/images/blog/placeholder.jpg'}
                                    alt={`${article.titolo || t('blog.article.imageAltFallback')}`}
                                />
                                <div className="py-3">
                                    {article.nomeCategoria && (
                                        <div className="blog-post-category mb-2">
                                            <strong>{article.nomeCategoria}</strong>
                                        </div>
                                    )}
                                    <h5 className="mb-2">{he.decode(article.titolo)}</h5>
                                    <p className="mb-2">{he.decode(`${article.testoRidotto}`) || t('blog.article.noShortDescription')}</p>
                                    <div className="public-data">
                                        <i className="far fa-clock mr-1"></i>
                                        <span>{formatDate(article.dataPubblicazione, t)}</span>
                                    </div>

                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    )
}
export default LastArticles